// styled-components dropped `$`-prefixed ("transient") props before they reached the wrapped component.
// Emotion only filters props for DOM tags, so components wrapped with `styled(Component)` use this to keep
// that behaviour (plus MUI's own defaults of not forwarding `ownerState`, `theme`, `sx` and `as`).
export const transientProps = (prop: PropertyKey) =>
  typeof prop !== 'string' ||
  (!prop.startsWith('$') && prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as');
